import InputComponent from './container'

export default InputComponent
